import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const ForgeHeaderModule = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "portal-forge-ui-header" */ './portal-header')),
    LoadingSkeleton: () => null,
});
